import {useRegionConfig} from './useRegionConfig'
import {useUserData} from './useUserData'

// Получить полное имя авторизованного пользователя.
export function useFullUserName(
    preferVayvndName?: boolean,
    defaultValue: string = '-'
) {
    const user = useUserData()
    const regionConfig = useRegionConfig()
    if (!user) {
        return defaultValue
    }
    if (
        preferVayvndName
        && user.details.firstName?.length
        && user.details.lastName?.length
    ) {
        return regionConfig.makeFullUserName(user.details.firstName, user.details.lastName)
    }
    return `${user.fullName}`
}
